export const gaceta_item = [
  {
    gaceta_item_titulo_imagen: "No. 1 2023",
    gaceta_item_imagen: "/contenido/informacion/gaceta/2023/gaceta 1 2023.png",
    gaceta_item_url: "/contenido/informacion/gaceta/2023/GHIS-2023.Entera.pdf",
    gaceta_item_list: [
      <ul>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2023/GHIS-2023.Editorial.pdf" target="_blank">1 - Editorial</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2023/GHIS-2023.SobrepesoyObesidad.pdf" target="_blank">2 - Factores de riesgo asociados a sobrepeso y obesidad infantil</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2023/GHIS-2023.Calidad.pdf" target="_blank">8 - Satisfacción del usuario de los Servicios de Salud de Hidalgo como variable indicadora de calidad</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2023/GHIS-2023.SaludMental.pdf" target="_blank">13 - Salud mental: una materia pendiente para las políticas en salud</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2023/GHIS-2023.Diplomado.pdf" target="_blank">18 - Diplomado en Metodología de la Investigación</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2023/GHIS-2023.Normas.pdf" target="_blank">19 - Normas de publicación</a></li>
</ul>
    ],
  },
  {
    gaceta_item_titulo_imagen: "No. 1 2022",
    gaceta_item_imagen: "/contenido/informacion/gaceta/2022/Gaceta 4 2022.png",
    gaceta_item_list: [
      <ul>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2022/Gaceta-1-2022.Editorial 2.pdf">1 - Editorial</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2022/Gaceta-1-2022.CalidadVidaHospGeneral 2.pdf">2 - Calidad de vida profesional, satisfacción por empatía, desgaste por compasión y síndrome de Burnout vs. COVID-19 en personal del Hospital General Pachuca, 2020 - 2021</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2022/Gaceta-1-2022.DiarreaMéxico 2.pdf">8 - Diarrea aguda en México. Revisión epidemiológica actual</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2022/Gaceta-1-2022.PercepciónCovid 2.pdf">12 - Consideraciones de la percepción de riesgo ante COVID-19</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2022/Gaceta 1-2022.Instrucciones.pdf">15 - Instrucciones para los autores</a></li>
</ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 3 JULIO-SEPTIEMBRE 2021",
    gaceta_item_imagen: "/contenido/informacion/gaceta/2021/Gaceta 3 2021.JPG",
    gaceta_item_list: [
      <ul>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2021/Gaceta.2021.3.Editorial.pdf">1 - Editorial</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2021/Gaceta.2021.3.EnseñanzasPandemia.pdf">2 - Enseñanzas de la pandemia</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2021/Gaceta.2021.3.Inmunoterapia.pdf">6 - Inmunoterapia, una esperanza para el paciente con cáncer</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2021/Gaceta.2021.3.Ovitrampas.pdf">8 - Efectividad y diversidad de las ovitrampas para el control de A. aegypti</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2021/Gaceta.2021.3.SexualidadyEducacion.pdf">11 - Sexualidad infantil y educación</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2021/Gaceta.2021.3.InstruccionesAutores.pdf">14 - Instrucciones para los autores</a></li>
</ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 2 ABRIL-JUNIO 2021",
    gaceta_item_imagen: "/contenido/informacion/gaceta/2021/Gaceta 2 2021.JPG",
    gaceta_item_list: [
      <ul>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2021/Editorial_G22021.pdf">1 - Editorial</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2021/Artículo-Caso_G22021.pdf">2 - Cuadro clínico simultáneo de varicela y herpes zoster en una menor de 12 años de la Huasteca Hidalguense, México</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2021/Origen-Covid_G22021.pdf">6 - Tras el origen de la pandemia. Tres historias de médicos chinos que pudieron cambiar el rumbo de la enfermedad</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2021/Percepción-Covid_G22021.pdf">8 - Percepción de riesgo ante COVID-19</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2021/Estrés-HT_G22021.pdf">11 - Estrés e hipertensión arterial</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2021/Instrucciones-Autores_G22021.pdf">14 - Instrucciones para los autores</a></li>
</ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 1 ENERO-MARZO 2021",
    gaceta_item_imagen: "/contenido/informacion/gaceta/2021/Gaceta 1 2021.JPG",
    gaceta_item_list: [
      <ul>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2021/Editorial.Gaceta-2021-1.pdf">1 - Editorial</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2021/Artículo-Cesárea.Gaceta-2021-1.pdf">2 - Caracterización de la operación cesárea en el Hospital General de la Huasteca, según clasificación de Robson</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2021/Artículo-Ecosalud.Gaceta-2021-1.pdf">6 - Enfoque ecosalud para el control de enfermedades transmitidas por vector</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2021/Artículo-ReflexionesPandemia.Gaceta-2021-1.pdf">8 - Reflexiones en torno a la salud mental y educación en el contexto de la pandemia 2020-21</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2021/Artículo-Agua.Gaceta-2021-1.pdf">11 - Agua limpia y saneamiento: determinantes sociales de la salud</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2021/InstruccionesAutores.Gaceta-2021-1.pdf">14 - Instrucciones para los autores</a></li>
</ul>

    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 4 OCTUBRE-DICIEMBRE 2020",
    gaceta_item_imagen: "/contenido/informacion/gaceta/2020/Gaceta 4 2020.JPG",
    gaceta_item_list: [
      <ul>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/4Portada.Gaceta-2020.pdf">Portada</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/4Editorial.Gaceta-2020.pdf">1 - Editorial</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/4DM.Glucemia.Gaceta-2020.pdf">3 - Factores asociados al descontrol glucémico en pacientes con diabetes mellitus tipo 2 en la Jurisdicción Sanitaria VII, Actopan, Hidalgo, México</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/4Fibra.Glucemia.Gaceta-2020.pdf">7 - Evaluación de la ingesta de hidratos de carbono, azúcares simples, energía y fibra en la dieta de pacientes con diabetes en control y descontrol glucémico de Pachuca</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/4Repelentes.Gaceta-2020.pdf">11 - Plantas repelentes como auxiliares en el control del mosquito transmisor del dengue, Zika y chikungunya</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/4Nosotras.Gaceta-2020.pdf">14 - Nosotras, las mujeres</a></li>
</ul>

    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 3 JULIO-SEPTIEMBRE 2020",
    gaceta_item_imagen: "/contenido/informacion/gaceta/2020/Gaceta 3 2020.JPG",
    gaceta_item_list: [
      <ul>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.2020-3.Portada.pdf">Portada</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.2020-3.Editorial.pdf">2 - Editorial</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.2020-3.DesarrolloyCrecimiento.pdf">3 - Desigualdad y crecimiento, canales y evidencia para México, 2008-2018</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.2020-3.EvoluciónCerebro.pdf">9 - La evolución del ser humano y su cerebro, desde una perspectiva paleontológica</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.2020-3.Diabetes.Sars-CoV2.pdf">12 - Diabetes e infección por SARS-CoV-2</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.2020-3.Hipertensión.Sars-Cov2.pdf">14 - Enfermedad de COVID-19 e hipertensión arterial</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.2020-3.Instrucciones.pdf">16 - Instrucciones para los autores de la Gaceta Hidalguense de Investigación en Salud</a></li>
</ul>

    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 2 ABRIL-JUNIO 2020",
    gaceta_item_imagen: "/contenido/informacion/gaceta/2020/Gaceta 2 2020.PNG",
    gaceta_item_list: [
      <ul>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.2020-2.Portada.pdf">Portada</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.2020-2.Editorial.pdf">1 - Editorial</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.2020-2.AlimentosFuncionales.pdf">3 - Alimentos funcionales</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.2020-2.Fibra.pdf">6 - La fibra y su papel en la prevención de enfermedades</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.2020-2.Sarampión.pdf">9 - Brote de Sarampión en México: avances en inmunización y retos</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.2020-2.Eventos.pdf">12 - Eventos</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.2020-2.Instrucciones.pdf">13 - Instrucciones para los autores de la Gaceta Hidalguense de Investigación en Salud</a></li>
</ul>

    ],
  },

  {
    gaceta_item_titulo_imagen: "COVID-19 NÚMERO ESPECIAL",
    gaceta_item_imagen: "/contenido/informacion/gaceta/2020/gaceta especial.JPG",
    gaceta_item_list: [
      <ul>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.Especial.Portada.pdf">Portada</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.Especial.1.Editorial_Bueno.pdf">2 - Editorial</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.Especial.2-Martell.pdf">3 - Pandemia por coronavirus SARS-CoV-2 / COVID-19: un enfoque inmunológico</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.Especial.3-Ocampo_Bueno.pdf">5 - Respuesta inmune y características clínicas y epidemiológicas de la infección por SARS-CoV-2</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.Especial.4-Menchaca.pdf">13 - Características genéticas y evolutivas de SARS-CoV-2</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.Especial.5-Zaragoza_Bueno.pdf">16 - Infección por SARS-CoV-19 durante el embarazo y lactancia materna</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.Especial.6-Norato.pdf">19 - Actualizaciones en el tratamiento de la nueva infección respiratoria aguda (COVID-19)</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/G.Especial.7-Miranda.pdf">23 - Salud mental ante el coronavirus</a></li>
</ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 1 ENERO-MARZO 2020",
    gaceta_item_imagen: "/contenido/informacion/gaceta/2020/Gaceta 1 2020.JPG",
    gaceta_item_list: [
      <ul>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/Gaceta-2020-1-Portada.pdf">Portada</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/Gaceta-2020-1-Editorial.pdf">1 - Editorial</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/Gaceta-2020-1-Art.Tabaco.pdf">2 - El despojo de los valores sagrados del tabaco</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/Gaceta-2020-1-Art.RetenciónPeso.pdf">5 - Retención de peso postparto y lactancia materna</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/Gaceta-2020-1-Art.Parafilias.pdf">7 - ¿Qué son las parafilias?</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/Gaceta-2020-1-Art.Coronavirus.pdf">10 - “Otra década, otro coronavirus”</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/Gaceta-2020-1-Eventos.pdf">12 - Eventos</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/2020/Gaceta-2020-1-InstruccionesAutores.pdf">13 - Instrucciones para los autores de la Gaceta Hidalguense de Investigación en Salud</a></li>
</ul>

    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 2 OCTUBRE-DICIEMBRE 2019",
    gaceta_item_imagen: "/contenido/informacion/gaceta/Gaceta 2 2019.JPG",
    gaceta_item_list: [
    <ul>
  <li className="archivo-pdf"><a href="/contenido/transparencia/armonizacion/2019/2019-2-Portada.pdf">Portada</a></li>
  <li className="archivo-pdf"><a href="/contenido/transparencia/armonizacion/2019/2019-2-Editorial.pdf">1 - Editorial</a></li>
  <li className="archivo-pdf"><a href="/contenido/transparencia/armonizacion/2019/2019-2-DesviaciónPositiva.pdf">2 - Desviación positiva y diversidad alimentaria en niños de una</a></li>
  <li className="archivo-pdf"><a href="/contenido/transparencia/armonizacion/2019/2019-2-Insulinización.pdf">9 - Insulinización temprana en el paciente diabético</a></li>
  <li className="archivo-pdf"><a href="/contenido/transparencia/armonizacion/2019/2019-2-VariantesExistencia.pdf">11 - Las variantes de la existencia</a></li>
</ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 1 ENERO-MARZO 2019",
    gaceta_item_imagen: "/contenido/informacion/gaceta/Gaceta 1 2019.JPG",
    gaceta_item_list: [
      <ul>
  <li className="archivo-pdf"><a href="/contenido/transparencia/armonizacion/2019/Gaceta-2019-1_Portada.pdf">Portada</a></li>
  <li className="archivo-pdf"><a href="/contenido/transparencia/armonizacion/2019/Gaceta-2019-1_Editorial.pdf">1 - Editorial</a></li>
  <li className="archivo-pdf"><a href="/contenido/transparencia/armonizacion/2019/Gaceta-2019-1_DeterminantesMuerteMaterna.pdf">2 - Determinantes sociales de la muerte materna</a></li>
  <li className="archivo-pdf"><a href="/contenido/transparencia/armonizacion/2019/Gaceta-2019-1_InfluenciasocialismoMujer.pdf">6 - Influencia del socialismo en el Día Internacional de la Mujer</a></li>
  <li className="archivo-pdf"><a href="/contenido/transparencia/armonizacion/2019/Gaceta-2019-1_Chagas.pdf">9 - Enfermedad de Chagas</a></li>
  <li className="archivo-pdf"><a href="/contenido/transparencia/armonizacion/2019/Gaceta-2019-1_TransmisiónChagas.pdf">13 - Transmisión congénita de la enfermedad de Chagas</a></li>
</ul>
    ],
  },
  
  {
    gaceta_item_titulo_imagen: "No. 4 OCTUBRE-DICIEMBRE 2018",
    gaceta_item_imagen: "/contenido/informacion/gaceta/Gaceta 4 2018.jpg",
    gaceta_item_list: [
      <ul>
  <li className="archivo-pdf"><a href="/contenido/transparencia/armonizacion/Segundo 20Trimestre 202019/1. 20INFORMACION 20CONTABLE/ESTADO 20DE 20ACTIVDADES.pdf">Estado de actividades</a></li>
  <li className="archivo-pdf"><a href="/contenido/transparencia/armonizacion/Segundo 20Trimestre 202019/1. 20INFORMACION 20CONTABLE/ESTADO 20ANALITICO 20DEL 20ACTIVO.pdf">Estado analítico del activo</a></li>
  <li className="archivo-pdf"><a href="/contenido/transparencia/armonizacion/Segundo 20Trimestre 202019/1. 20INFORMACION 20CONTABLE/ESTADO 20ANALITICO 20DE 20LA 20DEUDA 20Y 20OTROS 20PASIVOS.pdf">Estado analítico de la deuda y otros pasivos</a></li>
  <li className="archivo-pdf"><a href="/contenido/transparencia/armonizacion/Segundo 20Trimestre 202019/1. 20INFORMACION 20CONTABLE/ESTADO 20DE 20CAMBIOS 20EN 20LA 20SITUACION 20FINANCIERA.pdf">Estado de cambios en la situación financiera</a></li>
</ul>

    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 3 JULIO-SEPTIEMBRE 2018",
    gaceta_item_imagen: "/contenido/informacion/gaceta/Gaceta 3 2018.jpg",
    gaceta_item_list: [
      <ul>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/Gaceta18_3_Portada.pdf">Portada</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/Gaceta18_3_Realidad%20virtual.pdf">Implementación y evaluación de un programa de realidad virtual para prevenir conductas alimentarias de riesgo relacionadas con insatisfacción corporal en hombres adolescentes</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/Gaceta18_3_Autoeficacia.pdf">Diferencias por sexo en la autoeficacia para el control de peso en preadolescentes de la ciudad de Pachuca, Hidalgo</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/Gaceta18_3_Malestar%20emocional.pdf">Malestar emocional en parejas, hijos e hijas de migrantes</a></li>
</ul>

    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 2 ABRIL-JUNIO 2018",
    gaceta_item_imagen: "/contenido/informacion/gaceta/Gaceta 2 2018.jpg",
    gaceta_item_list: [
      <ul>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/Gaceta_18_2_Portada.pdf">Portada</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/Gaceta_18_2_Directorio.pdf">Directorio</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/Gaceta_18_2_Editorial.pdf">Editorial</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/Gaceta_18_2_Art.Plataformas%20colaborativas.pdf">Plataformas colaborativas: nuevas estrategias de vigilancia entomológica</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/Gaceta_18_2_Art.RolTejidoAdiposo.pdf">El rol del tejido adiposo en enfermedades transmitidas por vectores</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/Gaceta_18_2_Art.ParticipaciónComunitaria.pdf">Participación comunitaria en la prevención del dengue</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/Gaceta_18_2_Art.Paludismo.pdf">Pasado y presente del paludismo</a></li>
  <li className="archivo-pdf"><a href="/contenido/informacion/gaceta/Gaceta_18_2_Art.Chagas.pdf">Notas generales de la enfermedad de Chagas</a></li>
</ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 1 ENERO-MARZO 2018",
    gaceta_item_imagen: "/contenido/informacion/gaceta/Gaceta 1 2018.jpg",
    gaceta_item_list: [
      <ul>
					<li className="archivo-pdf">
          <a href="/contenido/informacion/gaceta/Gaceta 1 2018.jpg">1 - Editorial.</a>
        </li>
        <li className="archivo-pdf">
          <a href="/contenido/informacion/gaceta/Gaceta 1 2018.jpg">2 - Efecto de un tratamiento nutricional con probióticos en niños con obesidad.</a>
        </li>
        <li className="archivo-pdf">
          <a href="/contenido/informacion/gaceta/Gaceta 1 2018.jpg">6 - Evaluación de la circunferencia media del brazo y del pliegue tricipital en niños menores de 2 años y su relación con prácticas de alimentación.</a>
        </li>
        <li className="archivo-pdf">
          <a href="/contenido/informacion/gaceta/Gaceta 1 2018.jpg">12 - Controversias de la asociación entre estado nutricional e infección por dengue.</a>
        </li>
        <li className="archivo-pdf">
          <a href="/contenido/informacion/gaceta/Gaceta 1 2018.jpg">16 - Reflexión para el debate: nutrición-inmunidad.</a>
        </li>
        <li className="archivo-pdf">
          <a href="/contenido/informacion/gaceta/Gaceta 1 2018.jpg">18 - Estilos de vida y estado nutricional del personal sanitario.</a>
        </li>
        <li className="archivo-pdf">
          <a href="/contenido/informacion/gaceta/Gaceta 1 2018.jpg">21 - Generalidades de las interacciones entre fármacos y nutrimentos.</a>
        </li>
      </ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 4 OCTUBRE-DICIEMBRE 2017",
    gaceta_item_imagen: "/contenido/informacion/gaceta/Gaceta 18 2017.jpg",
    gaceta_item_list: [
      <ul>
        <li className="archivo-pdf">
        <a href="/contenido/informacion/gaceta/Gaceta 18 2017.pdf">1 - Editorial.</a>
      </li>
      <li className="archivo-pdf">
        <a href="/contenido/informacion/gaceta/Gaceta 18 2017.pdf">2 - Validación de instrumentos para la identificación de trastornos por consumo de alcohol en adolescentes indígenas: POSIT y AUDIT.</a>
      </li>
      <li className="archivo-pdf">
        <a href="/contenido/informacion/gaceta/Gaceta 18 2017.pdf">7 - Obesidad, tejido adiposo visceral y resistencia a la insulina.</a>
      </li>
      <li className="archivo-pdf">
        <a href="/contenido/informacion/gaceta/Gaceta 18 2017.pdf">11 - La psicosis paranoica desde una perspectiva clínica.</a>
      </li>
      <li className="archivo-pdf">
        <a href="/contenido/informacion/gaceta/Gaceta 18 2017.pdf">13 - Importancia del uso racional de medicamentos.</a>
      </li>
      <li className="archivo-pdf">
        <a href="/contenido/informacion/gaceta/Gaceta 18 2017.pdf">15 - Ambiente y su impacto en salud.</a>
      </li>
      <li className="archivo-pdf">
        <a href="/contenido/informacion/gaceta/Gaceta 18 2017.pdf">18 - Apuntes sobre Alzheimer.</a>
      </li>
    </ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 3 JULIO-SEPTIEMBRE 2017",
    gaceta_item_imagen: "/contenido/informacion/gaceta/Gaceta 17 2017.jpg",
    gaceta_item_list: [
      <ul>
      <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 17 2017.pdf">1 - Editorial.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 17 2017.pdf">2 - Evaluación del modelo de atención del parto vertical en el Hospital General de Tula, Hidalgo.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 17 2017.pdf">8 - Abandono de la lactancia materna y barreras socioculturales.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 17 2017.pdf">12 - Enfermedad de Chagas en Hidalgo.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 17 2017.pdf">16 - Normas de Buenas Prácticas Clínicas.</a>
    </li>
  </ul>
    ],
  },
  
  {
    gaceta_item_titulo_imagen: "No. 2 ABRIL-JUNIO DE 2017",
    gaceta_item_imagen: "/contenido/informacion/gaceta/Gaceta 16 2017.jpg",
    gaceta_item_list: [
      <ul>
      <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 16 2017.pdf">1 - Editorial.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 16 2017.pdf">2 - Factores asociados a caries dental en preescolares y escolares indígenas nahuas.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 16 2017.pdf">7 - Asociación entre las variables climáticas y los casos de dengue en el estado de Hidalgo.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 16 2017.pdf">9 - Burnout en el personal de enfermería del primer nivel de atención de la Secretaría de Salud de Hidalgo.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 16 2017.pdf">14 - La mecánica defensiva del personaje psicópata en sus relaciones objetales: su formación, expresión y relación con el narcisismo.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 16 2017.pdf">16 - Diversidad de la dieta: indicador para evaluar la calidad y seguridad de la alimentación infantil.</a>
    </li>
  </ul>
    ],
  },
  
  {
    gaceta_item_titulo_imagen: "No. 1 ENERO-MARZO DE 2017",
    gaceta_item_imagen: "/contenido/informacion/gaceta/gaceta 15 2017.jpg",
    gaceta_item_list: [
      <ul>
      <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 15 2017.pdf">1 - Editorial.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 15 2017.pdf">3 - Recolección de heces caninas en los parques de Pachuca, hidalgo.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 15 2017.pdf">7 - Vigencia de la infección crónica por Mycobacterium tuberculosis.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 15 2017.pdf">10 - Percepción Materna del Peso del Hijo (PMPH) y subestimación del sobrepeso-obesidad infantil.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 15 2017.pdf">13 - Gerencia y liderazgo en los sistemas de salud.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 15 2017.pdf">16 - Enfermedades transmitidas por dípteros vectores.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 15 2017.pdf">19 - La importancia de la consulta terapéutica en el apego al tratamiento.</a>
    </li>
  </ul>
    ],
  },  
  
  {
    gaceta_item_titulo_imagen: "No. 14 OCTUBRE-DICIEMBRE DE 2016",
    gaceta_item_imagen: "/contenido/informacion/gaceta/Gaceta 14.jpg",
    gaceta_item_list: [
      <ul>
      <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 14.pdf">1 - Editorial.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 14.pdf">2 - Eficacia del rociado espacial de insecticidas para el control del dengue.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 14.pdf">6 - Psicoanálisis de la psicopatía y la neurosis: conexión y contraste.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 14.pdf">8 - Cambio climático y seguridad alimentaria, riesgos de un futuro próximo.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 14.pdf">11 - VIH/SIDA, ¿cómo estamos y hacia dónde vamos?.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 14.pdf">13 - A propósito del Día Internacional del Cáncer Mamario.</a>
    </li>
  </ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 13 JULIO-SEPTIEMBRE DE 2016",
    gaceta_item_imagen: "/contenido/informacion/gaceta/Gaceta 13.jpg",
    gaceta_item_list: [
            <ul>
      <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 13 Autorizada.pdf">1 - Editorial.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 13 Autorizada.pdf"> 2 - Impacto de la actividad física laboral sobre la aptitud física en una dependencia de los Servicios de Salud de Hidalgo.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 13 Autorizada.pdf">7 - Dieta DASH e hipertensión arterial en el Día Mundial del Corazón.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 13 Autorizada.pdf">9 - El modelo constructivista en la educación para la salud.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 13 Autorizada.pdf">11 - Conoce la hepatitis y actúa ya.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 13 Autorizada.pdf">13 - Día Mundial para la Prevención del Suicidio.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 13 Autorizada.pdf">15 - Entrevista al Lic. Hilario Flores Luna.</a>
    </li>
    
  </ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 12 ABRIL-JUNIO DE 2016",
    gaceta_item_imagen: "/contenido/informacion/gaceta/Gaceta12.jpg",
    gaceta_item_list: [
      <ul>
      <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 12.pdf">1 - Editorial.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 12.pdf">2 - Actualidad de la enfermedad inflamatoria intestinal y su abordaje nutricional.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 12.pdf">6 - La condición esquizoide desde el psicoanálisis.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 12.pdf">10 - Depresión en el adulto mayor.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 12.pdf">13- Importancia y trascendencia del Día Mundial del Ensayo Clínico.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 12.pdf">16- Principales complicaciones del embarazo en adolescentes.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 12.pdf">19- Día Mundial de la Hipertensión.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta 12.pdf">21- Entrevista a la MAH. Gloria Monzalvo Herrera.</a>
    </li>    
  </ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 11 ENERO-MARZO DE 2016",
    gaceta_item_imagen: "/contenido/informacion/gaceta/Gaceta11.jpg",
    gaceta_item_list: [
      <ul>
      <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta11.pdf">1 - Editorial.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta11.pdf">2 - Utilidad de la Escala de Alvarado en el diagnóstico clínico de apendicitis aguda en un hospital del sur de México.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta11.pdf">6 - La gestión del conocimiento como herramienta para la implementación de Proyectos Estratégicos de Salud en Hidalgo.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta11.pdf">9 - Empoderamiento de la mujer, una larga lucha que aún no termina.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta11.pdf">12- Tuberculosis: metas y tratamiento con miras a su erradicación.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta11.pdf">15- Principales consideraciones del cáncer infantil.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta11.pdf">17- Día Mundial del Riñón: por una cultura de prevención.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta11.pdf">19- Entrevista al Dr. Miguel Ángel Castellanos Salgado.</a>
    </li>    
  </ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "SIMPOSIO DENGUE EN HIDALGO, RETOS Y OPRTUNIDADES.",
    gaceta_item_imagen: "/contenido/informacion/gaceta/Cartel Dengue-Arista_2016.jpg",
    gaceta_item_list: [
      <a href="/contenido/informacion/gaceta/Cartel Dengue-Arista_2016.jpg" target="_blank">Simposio dengue en Hidalgo, retos y Oportunidades.</a>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 10 OCTUBRE-DICIEMBRE DE 2015",
    gaceta_item_imagen: "/contenido/informacion/gaceta/10.jpg",
    gaceta_item_list: [
      <ul>
      <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta10.pdf">1 - Editorial.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta10.pdf">2 - Maltrato en adultos mayores calidad de vida en Hidalgo, México.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta10.pdf">7 - El suicidio en el mundo y en México.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta10.pdf">10- Seguridad alimentaria, nutrición y políticas públicas para la protección a la salud.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta10.pdf">15- Salud Reproductiva y perspectiva de género.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta10.pdf">18- Chikungunya, su aparición y dispersión.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta10.pdf">20- Cáncer de mama y autoexploración.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta10.pdf">24- Entrevista al Dr. en C. J. Diego Urbe Escamilla.</a>
    </li>    
  </ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 9 JULIO - SEPTIEMBRE DE 2015",
    gaceta_item_imagen: "/contenido/informacion/gaceta/9.jpg",
    gaceta_item_list: [
      <ul>
      <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta_9.pdf">1 - Editorial.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta_9.pdf">6 - Adherencia farmacológica en pacientes con diabetes tipo 2 de los Grupos de Ayuda Mutua en una jurisdicción de los Servicios de Salud de Hidalgo.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta_9.pdf">9 - Jarabe de maíz alto en fructosa, una revisión sobre su metabolismo y efectos de un consumo excesivo.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta_9.pdf">12- Ser líder, propósito actual del administrador de los servicios de salud.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta_9.pdf">14- Impacto de la atención en salud en la hipertensión arterial.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta_9.pdf">16- Día Mundial de la Alimentación. Del contexto mundial al panorama en Hidalgo.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta_9.pdf">18- Día Mundial de la Respuesta al VIH/Sida.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta_9.pdf">19- Entrevista al Dr. en C. Moisés Ocampo Torres.</a>
    </li>    
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta_9.pdf">20- Eventos en salud.</a>
    </li> 
  </ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 8 ABRIL - JUNIO DE 2015",
    gaceta_item_imagen: "/contenido/informacion/gaceta/8abriljunio2015.jpg",
    gaceta_item_list: [
     <ul> 
      <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta8.pdf">1. Editorial</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta8.pdf">2 - Prevalencia de cáncer cérvico uterino, lesiones premalignas y actores asociados en una institución pública del estado de Hidalgo.</a>
    </li>   
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta8.pdf">7 - Reacciones adversas a los medicamentos en adultos mayores en tres dependencias de salud de Hidalgo, México.</a>
    </li>   
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta8.pdf">12- Alternativa de participación comunitaria en la vigilancia entomológica de A. aegypti.</a>
    </li>   
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta8.pdf">15- Cocina tradicional mexicana, patrimonio inmaterial de la humanidad.</a>
    </li>   
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta8.pdf">19- Entrevista al Dr. José Antonio Copca García.</a>
    </li>      
  </ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 7 ENERO - MARZO DE 2015",
    gaceta_item_imagen: "/contenido/informacion/gaceta/7eneromarzo2015.jpg",
    gaceta_item_list: [
     <ul> 
      <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta7.pdf">1.- Editorial</a>
    </li>    
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta7.pdf">2 - Caracterización epidemiológica de la tuberculosis pulmonar en el estado de Hidalgo, México.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta7.pdf">6 - Cobertura efectiva del programa de tuberculosis en el estado de Hidalgo.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta7.pdf">10- Caracterización de las infecciones nosocomiales en los hospitales de los Servicios de Salud de Hidalgo.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta7.pdf">14- 15 de octubre: Día mundial del lavado de manos.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta7.pdf">16- El fatídico acto de fumar.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/Gaceta7.pdf">19- Entrevista a la MSP. María Dolores Osorio Piña.</a>
    </li>
  </ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 6 OCTUBRE - DICIEMBRE DE 2014",
    gaceta_item_imagen: "/contenido/informacion/gaceta/gaceta6.jpg",
    gaceta_item_list: [
     <ul> 
      <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta6.pdf">1 - Editorial.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta6.pdf">2 - Determinantes sociales y del sistema de salud en la de muerte materna en el Estado de Hidalgo presencia.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta6.pdf">6 - Estimación del nivel de conocimientos del personal de salud sobre infecciones nosocomiales, lavado de manos y 
      medidas de prevención en hospitales de los Servicios de Salud de Hidalgo.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta6.pdf">11- Aptitud y actividad física: factores protectores contra la obesidad.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta6.pdf">14- Revisión teórica del bullying.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta6.pdf">18- Interacciones entre medicamentos y alimentos.</a>
    </li>   
  </ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 5 OCTUBRE - DICIEMBRE DE 2013",
    gaceta_item_imagen: "/contenido/informacion/gaceta/gaceta5.jpg",
    gaceta_item_list: [
     <ul> 
      <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta5.pdf">1.- Editorial</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta5.pdf">2 - Evaluación de la cobertura efectiva del programa de cáncer cérvico uterino e identificación de barreras en el acceso.</a>
    </li> 
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta5.pdf">6 - Inteligencias múltiples y estilos de aprendizaje en alumnos de alto rendimiento de la Escuela de Medicina de la UAEH.</a>
    </li> 
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta5.pdf">11- El combate al dengue, ¿una batalla perpetua?.</a>
    </li> 
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta5.pdf">15- Decálogo para el cuidado del riñón.</a>
    </li> 
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta5.pdf">17- Día mundial de la tuberculosis.</a>
    </li> 
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta5.pdf">19- 4 de febrero, Día Mundial contra el Cáncer.</a>
    </li>
  </ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 4 JULIO - SEPTIEMBRE DE 2013",
    gaceta_item_imagen: "/contenido/informacion/gaceta/gaceta4.jpg",
    gaceta_item_list: [
     <ul> 
      <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta4.pdf">1.- Editorial</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta4.pdf">2 - Streptococcus del grupo B en el embarazo y su relación con algunas complicaciones obstétricas.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta4.pdf">6 - Accidentes de tránsito en Hidalgo.</a>
    </li>    
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta4.pdf">9- Influencia de la degradación ambiental sobre la salud de las mujeres en Los  Altos de Chiapas.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta4.pdf">17- La profesionalización de enfermeria en México.</a>
    </li>
  </ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 3 ABRIL - JUNIO DE 2013",
    gaceta_item_imagen: "/contenido/informacion/gaceta/gaceta3.jpg",
    gaceta_item_list: [
     <ul>
      <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta3.pdf">1.- Editorial</a>
    </li>
      <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta3.pdf">2 - Frecuencia del Síndrome de burnout en el personal de enfermería del Hospital    de las Culturas.</a>
    </li>   
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta3.pdf">8 - Consumo de alcohol y tabaco y su efecto en el rendimiento escolar de estudiantes del Área Académica de 
      Medicina de la Universidad Autónoma del Estado de Hidalgo.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta3.pdf">12- El consumo de drogas ilegales en Hidalgo: Un reto de salud pública.</a>
    </li> 
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta3.pdf">15- Aproximación al fenómeno de la droga desde la tecnología.</a>
    </li> 
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta3.pdf">17- Violencia contra la mujer y empoderamiento.</a>
    </li> 
  </ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 2 ENERO - MARZO DE 2013",
    gaceta_item_imagen: "/contenido/informacion/gaceta/gaceta2.jpg",
    gaceta_item_list: [
     <ul>
      <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta2.pdf">1.- Editorial</a>
    </li>
      <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta2.pdf">2 - Prevalencia de sobrepeso, obesidad y factores asociados a diabetes y enfermedad cardiovascular en escolares del estado de Hidalgo, México.</a>
    </li>   
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta2.pdf">6 - Perfil clinico-epidemiológico y prevalencia de resistencia a la insulina en niños y adolescentes con sobrepeso y obesidad mediante un modelo homeostático.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta2.pdf">9 - Detección temprana de nefropatía diabética en pacientes atendidos en las clínicas de diabetes del estado de Hidalgo.</a>
    </li> 
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta2.pdf">12- Análisis de cuerpos de agua termal en albercas por    la presencia de amebas de vida libre y su resistencia a los sistemas 
      de saneamiento en Hidalgo.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta2.pdf">15- Calidad aeromicrobiológica intrahospitalaria y la epidemiología ambiental, un reto en el tercer nivel de atención.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta2.pdf">21- Los biosólidos: ¿un beneficio o un riesgo para la salud en México?.</a>
    </li> 
  </ul>
    ],
  },

  {
    gaceta_item_titulo_imagen: "No. 1 OCTUBRE - DICIEMBRE DE 2012",
    gaceta_item_imagen: "/contenido/informacion/gaceta/gaceta1.jpg",
    gaceta_item_list: [
     <ul>
      <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta1.pdf">1.- Editorial</a>
    </li>
      <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta1.pdf">2 - Principales motivos para extracción dental en adultos que acuden a las clínicas odontológicas de la UAEH.</a>
    </li>   
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta1.pdf">7 - Trastornos de alimentación en estudiantes de secundaria y bachillerato en Hidalgo.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta1.pdf">10- Estudio de ecotoxicología e intervención nutricional en una comunidad de Hidalgo, México, con evidencias de toxicidad por manganeso.</a>
    </li> 
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta1.pdf">13- Colelitiasis en lactantes: reporte de un caso.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta1.pdf">17- El cutting: “Me corte profundo y se fue todo lo que sentía”.</a>
    </li>
    <li className="archivo-pdf">
      <a href="/contenido/informacion/gaceta/gaceta1.pdf">21- Normas de publicación para autores de la (Gaceta Hidalguense de Investigación en Salud).</a>
    </li>
  </ul>
    ],
  },
];



            
            
            
            
            
            
